import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.955 12.875a.726.726 0 0 1-.353.895l-.403.197c-1.854.76-3.091 1.033-3.982 1.033-2.287 0-2.293-1.797-4.543-1.797-.614 0-1.396.133-2.436.474-.497.162-1.155.393-1.155.393a.682.682 0 0 1-.216.036.715.715 0 0 1-.65-.425L4.054 4.025c-.143-.332.007-.679.357-.783l1.553-.46C7.722 2.216 8.966 2 9.87 2c3.107 0 2.213 2.57 4.413 2.57.445 0 1.016-.105 1.77-.357.192-.063 1.634-.512 1.634-.512a.648.648 0 0 1 .2-.03c.277 0 .545.17.653.447l3.415 8.757zM2.038 4.69a.5.5 0 0 1 .924-.38l7 17a.5.5 0 1 1-.924.38l-7-17z"
});

var SvgFlagFilled = function SvgFlagFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgFlagFilled;